module.exports = "/fonts/vendor/dropify/dist/dropify.svg?b321d818cc153b16e739072ea8bc94b8";